export const getFileIcon = (type: string) => {
    if (!type) {
        return "fa-file";
    }
    if (type.match("image.*")) {
        return "fa-file-image";
    } else if (type.includes("wordprocessing")) {
        return "fa-file-word";
    } else if (type.includes("spreadsheet")) {
        return "fa-file-excel";
    } else if (type.includes("pdf")) {
        return "fa-file-pdf";
    } else {
        return "fa-file";
    }
};
